var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl }},[_c('div',{staticClass:"columns columns--cards",style:({
      'background-color': _vm.useBackgroundColor,
      'padding-top': _vm.paddingTop + 'px',
      'padding-bottom': _vm.paddingBottom + 'px'
    }),on:{"click":function($event){return _vm.$emit('block:redirect')}}},_vm._l((_vm.blocksByTag),function(block,index){return _c('info-balloon',{key:index,class:`column col-${Math.round(12/_vm.blocksByTag.length)} md-col-${_vm.blocksByTag.length > 1 ? 6 : 12}`,attrs:{"fields":_vm.convertBlockFields(block)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }